module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "m_context plr"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    ref: "addForm",
    attrs: {
      "id": "addForm",
      "model": _vm.form,
      "label-width": "16%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.name')
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.name),
      callback: function($$v) {
        _vm.$set(_vm.form, "name", $$v)
      },
      expression: "form.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.version')
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.version),
      callback: function($$v) {
        _vm.$set(_vm.form, "version", $$v)
      },
      expression: "form.version"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.label_areaid')
    }
  }, [_c('MechanismSelector', {
    attrs: {
      "data": _vm.mechanismData,
      "mselect": true,
      "classs": 'w_33'
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.xzqddhwj')
    }
  }, [_c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "name": "fileUpload",
      "drag": "",
      "action": _vm.action,
      "on-success": _vm.handleAvatarScucess1,
      "before-upload": _vm.beforeAvatarUpload
    }
  }, [_c('i', {
    staticClass: "el-icon-upload"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-upload__text"
  }, [_vm._v(_vm._s(_vm.$t('lin_global.jwjtdcc'))), _c('em', [_vm._v(_vm._s(_vm.$t('lin_global.djsc')))])]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v(_vm._s(_vm.$t('lin_global.pleaseUpload')))])])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.qxzkjlogo')
    }
  }, [_c('el-upload', {
    staticClass: "avatar-uploader",
    attrs: {
      "name": "fileUpload",
      "action": _vm.action,
      "show-file-list": false,
      "on-success": _vm.handleAvatarScucess2,
      "before-upload": _vm.beforeAvatarUpload
    }
  }, [(_vm.imageUrl) ? _c('img', {
    staticClass: "avatar1",
    attrs: {
      "src": _vm.imageUrl
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon1"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v(_vm._s(_vm.$t('lin_global.tpxzds')))])])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.zmlaun')
    }
  }, [_c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "name": "fileUpload",
      "drag": "",
      "action": _vm.action,
      "on-success": _vm.handleAvatarScucess3,
      "before-upload": _vm.beforeAvatarUpload
    }
  }, [_c('i', {
    staticClass: "el-icon-upload"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-upload__text"
  }, [_vm._v(_vm._s(_vm.$t('lin_global.jwjtdcc'))), _c('em', [_vm._v(_vm._s(_vm.$t('lin_global.djsc')))])]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v(_vm._s(_vm.$t('lin_global.pleaseUpload')))])])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.xtjcb')
    }
  }, [_c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "name": "fileUpload",
      "drag": "",
      "action": _vm.action,
      "on-success": _vm.handleAvatarScucess4,
      "before-upload": _vm.beforeAvatarUpload
    }
  }, [_c('i', {
    staticClass: "el-icon-upload"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-upload__text"
  }, [_vm._v(_vm._s(_vm.$t('lin_global.jwjtdcc'))), _c('em', [_vm._v(_vm._s(_vm.$t('lin_global.djsc')))])]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v(_vm._s(_vm.$t('lin_global.pleaseUpload')))])])], 1), _vm._v(" "), _c('el-form-item', [_c('el-checkbox', {
    on: {
      "change": _vm.check
    },
    model: {
      value: (_vm.checked),
      callback: function($$v) {
        _vm.checked = $$v
      },
      expression: "checked"
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_global.zdqmTips')))])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "id": "onCancel"
    },
    on: {
      "click": _vm.onCancel
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_btn.cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.isSubmit
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_btn.add')))])], 1)], 1)], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1d297f4f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/system/romOrder.vue
// module id = 987
// module chunks = 0